import React from "react"
import ReactDOM from "react-dom"
import LogoSlider from "./logo-slider"

export default class LogoSliderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.data = JSON.parse(elem.dataset.model)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.render(<LogoSlider data={self.data.Elements} />, self.elem)
  }
}
